@layer reset, default;

@layer reset {
  :host {
    display: block;

    slot {
      display: initial;
    }
  }
}

@layer default {
  :host {
    .gcds-hint,
    gcds-text::part(text) {
      color: var(--gcds-hint-text);
    }

    .gcds-hint {
      margin: var(--gcds-hint-margin);
    }
  }
}
